import React, { useEffect, useState } from "react";
import { Button } from "reactstrap";
import './vault.css'
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
const Vault = () => {

     const [hoveredRing, setHoveredRing] = useState(null);
      const [selectedRing, setSelectedRing] = useState(null);
      const vaultproducts = useSelector((state) => state.product.vaultproducts) || [];
    const navigate = useNavigate();
      const viewDetails = (name, id) => {
  navigate(`/${encodeURIComponent(name.replaceAll(" ", "-"))}/${id}`);
};


    return(
       <div className="ring-showcase-slide">

          <div className="ring-showcase-header">
            <h2>The Ring Vault</h2>
            <p>Steal it before anyone else does</p>
          </div>

          <div className="ring-grid">

            {vaultproducts.map((ring, index) => (
              <div
                className={`ring-display ${index === 1 ? "featured-ring" : ""
                  }`}

              >

                <div className="ring-pocket"
                ></div>

                <div
                  className={`ring-rotator `}                >

                  <div
                    className="ring-box"


                  >

                    <img
                      src={ring.vaultImage}
                      alt={ring.name}
                      className="ring-image"

                      onMouseEnter={() => {
                        setHoveredRing(ring._id);
                      }}
                      onMouseLeave={() => {
                        setHoveredRing(null);
                      }}

                    />

                  </div>

                </div>

                <div
                  className={`ring-hover-details ${selectedRing === ring._id ? "mobile-show" : ""
                    }`}
                >
                  <span>
                    ₹{ring.defaultPrice?.toLocaleString()}
                  </span>
<Button
  onClick={(e) => {
    e.stopPropagation();
    viewDetails(ring.name, ring._id);
  }}
  className="ring-display-btn"
>
  View Details
</Button>                </div>
              </div>
            ))}

          </div>

        </div>
    )
}

export default Vault;